import { Stack, Alert } from "@mui/material";
import { SSText } from "src/components/base/components/SSText";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";
import { useEventCardCtx } from "../EventCard";
import { useGlobalStore } from "src/components/reusable/hooks/useGlobalStore";
import {
  isEventMaxSeatLimitReached,
  isReservationLimitReached,
} from "./utils.event-attendance";

export function EventCardAttendanceNotification() {
  const teamConfig = useTeamConfig();
  const { HOME_PAGE_SETTINGS } = teamConfig;
  const { md: mdUp } = useCssMediaQuery("up");
  const useOptedInCountForEventReservation = HOME_PAGE_SETTINGS?.EVENT_CARD?.USE_OPTED_IN_COUNT_FOR_EVENT_RESERVATION ?? false;
  const { passesOnAccount, events, optedInCountForEventReservation } = useGlobalStore();
  const eventCardCtx = useEventCardCtx();
  const event = eventCardCtx?.event;

  const isMaxReservationReached = isReservationLimitReached({
    passesOnAccount,
    events,
    event,
    optedInCountForEventReservation,
    useOptedInCountForEventReservation,
  });

  const isEventSeatLimitReached = isEventMaxSeatLimitReached(event);

  return (
    <>
      {isEventSeatLimitReached && !event?.optedIn ? (
        <Stack px={mdUp ? 3 : 2} mb={2}>
          <Alert severity="info">
            <SSText variant="body" fontSize={"0.9rem"} lineHeight={1.5}>
              {HOME_PAGE_SETTINGS?.EVENT_CARD
                ?.SEAT_COUNT_LIMIT_REACHED_MESSAGE ||
                "This event has reached its maximum seat limit"}
            </SSText>
          </Alert>
        </Stack>
      ) : null}

      {isMaxReservationReached && !event?.optedIn ? (
        <Stack px={mdUp ? 3 : 2} mb={2}>
          <Alert severity="info">
            <SSText variant="body" fontSize={"0.9rem"} lineHeight={1.5}>
              {HOME_PAGE_SETTINGS?.EVENT_CARD
                ?.RESERVATION_LIMIT_REACHED_MESSAGE ||
                "You have reached your maximum allowed active reservations"}
            </SSText>
          </Alert>
        </Stack>
      ) : null}
    </>
  );
}
